// Preserve the legacy switch cases and state updates during migration.
/* eslint-disable import/order */
import type {
  SetPositionCategoryType,
  SetPositionProductType,
  SetPositionPageType,
} from 'utils/apiList/setPosition'
import {
  SET_IS_START_SETPOS,
  SET_IS_FAILED_SETPOS,
  SET_IS_SUCCESS_SETPOS,
  SET_IS_PAGINATION_DATA_SETPOS,
  SET_IS_SUCCESS_SETPOS_CATEGORY,
  SET_IS_PAGINATION_DATA_SETPOS_CATEGORY,
  SET_IS_SUCCESS_SETPOS_PRODUCT,
  SET_IS_PAGINATION_DATA_SETPOS_PRODUCT,
  SET_IS_NEEN_TO_RELOAD_SETPOS,
  SET_IS_ALL_PRODUCT_ENTRY_POINT_SETPOS_CATEGORY,
} from 'storeContext/actionsType/setPosition'

export interface SetPositionPaginationType {
  currentItem: number
  currentPage: number
  pageSize: number
  totalData: number
  totalPage: number
}

export interface SetPositionStateType {
  isLoading: boolean
  setPosData: SetPositionCategoryType[]
  setPosPaginationData: Partial<SetPositionPaginationType>
  setPosCatData: SetPositionCategoryType[]
  setPosCatAllProductEntryPointData: Partial<SetPositionCategoryType>
  setPosCatPaginationData: Partial<SetPositionPaginationType>
  setPosProdData: SetPositionProductType[]
  setPosProdPaginationData: Partial<SetPositionPaginationType>
  needToReload: number
}

export type SetPositionActionType =
  | {
      type:
        | typeof SET_IS_START_SETPOS
        | typeof SET_IS_FAILED_SETPOS
        | typeof SET_IS_NEEN_TO_RELOAD_SETPOS
      payload?: never
    }
  | { type: typeof SET_IS_SUCCESS_SETPOS; payload: SetPositionCategoryType[] }
  | {
      type: typeof SET_IS_SUCCESS_SETPOS_CATEGORY
      payload: SetPositionPageType<SetPositionCategoryType>
    }
  | {
      type: typeof SET_IS_SUCCESS_SETPOS_PRODUCT
      payload: SetPositionPageType<SetPositionProductType>
    }
  | {
      type:
        | typeof SET_IS_PAGINATION_DATA_SETPOS
        | typeof SET_IS_PAGINATION_DATA_SETPOS_CATEGORY
        | typeof SET_IS_PAGINATION_DATA_SETPOS_PRODUCT
      payload: SetPositionPaginationType
    }
  | {
      type: typeof SET_IS_ALL_PRODUCT_ENTRY_POINT_SETPOS_CATEGORY
      payload: SetPositionCategoryType
    }

export const initialStateSetPosition: SetPositionStateType = {
  isLoading: false,
  setPosData: [],
  setPosPaginationData: {},
  setPosCatData: [],
  setPosCatAllProductEntryPointData: {},
  setPosCatPaginationData: {},
  setPosProdData: [],
  setPosProdPaginationData: {},
  needToReload: 1,
}

export default function setPosition(
  state = initialStateSetPosition,
  { type, payload }: SetPositionActionType,
): SetPositionStateType {
  switch (type) {
    case SET_IS_START_SETPOS:
      return {
        ...state,
        isLoading: true,
      }
    case SET_IS_FAILED_SETPOS:
      return {
        ...state,
        isLoading: false,
      }
    case SET_IS_SUCCESS_SETPOS:
      return {
        ...state,
        isLoading: false,
        setPosData: payload,
      }
    case SET_IS_PAGINATION_DATA_SETPOS:
      return {
        ...state,
        setPosPaginationData: payload,
      }
    case SET_IS_SUCCESS_SETPOS_CATEGORY:
      return {
        ...state,
        isLoading: false,
        setPosCatData: payload.content,
      }
    case SET_IS_PAGINATION_DATA_SETPOS_CATEGORY:
      return {
        ...state,
        setPosCatPaginationData: payload,
      }
    case SET_IS_SUCCESS_SETPOS_PRODUCT:
      return {
        ...state,
        isLoading: false,
        setPosProdData: payload.content,
      }
    case SET_IS_PAGINATION_DATA_SETPOS_PRODUCT:
      return {
        ...state,
        setPosProdPaginationData: payload,
      }
    case SET_IS_NEEN_TO_RELOAD_SETPOS:
      return {
        ...state,
        needToReload: state.needToReload + 1,
      }
    case SET_IS_ALL_PRODUCT_ENTRY_POINT_SETPOS_CATEGORY:
      return {
        ...state,
        setPosCatAllProductEntryPointData: payload,
      }
    default:
      return {
        ...state,
      }
  }
}
